<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import SubsidiaryLedgerTable from "@/components/widgets/subsidiary-ledger-table.vue";
import SubsidiaryLedgerModal from "@/components/modals/subsidiary-ledger-modal.vue";
import SubsidiaryLedgerTransactionsModal from "@/components/modals/subsidiary-ledger-transactions-modal.vue";
import Swal from "sweetalert2";

export default {
    name: "subsidiary-ledger",
    components: {
        Layout,
        PageHeader,
        SubsidiaryLedgerTable,
        SubsidiaryLedgerModal,
        SubsidiaryLedgerTransactionsModal
    },
    data() {
        return {
            title: "Subsidiary Ledgers",
            items: [
                {
                    text: "Dashboards",
                    href: "/",
                },
                {
                    text: "Finance",
                    href: "#",
                },
                {
                    text: "Subsidiary Ledgers",
                    active: true,
                },
            ],
            filter: null,
            subsidiaryLedgers: [],
            slTypes: [],
            loading: false,
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 25, 50, 100],
            modalTitle: "",
            // Add new data properties for transactions modal
            selectedSubsidiaryLedger: null,
            transactionsModalTitle: "",
        };
    },
    async created() {
        this.loading = true;
        await this.getSLTypes();
        await this.changeData(this.$store.state.data.cycle, this.$store.state.data.selectedCampus.id);
        this.loading = false;
    },
    methods: {
        async changeData(cycle, campusId) {
            this.loading = true;
            await this.getSubsidiaryLedgers(campusId);
            this.loading = false;
        },
        async getSubsidiaryLedgers(campusId) {
            await this.$store.dispatch("subsidiaryledger/getSubsidiaryLedgersByCampus", campusId)
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    this.subsidiaryLedgers = res.data.map(item => ({
                        ...item,
                        filterKey: `${item.accountNumber || ''} ${item.client || ''} ${item.projectName || ''} ${item.contractNo || ''} ${this.getSLTypeName(item.slTypeId)}`.toLowerCase()
                    }));
                })
                .catch((err) => {
                    this.showToast("Error fetching Subsidiary Ledgers", "error");
                });
        },
        async getSLTypes() {
            await this.$store
                .dispatch("sltype/getSLTypes")
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    this.slTypes = res.data;
                })
                .catch((err) => {
                    this.showToast("Failed to fetch SL Types", "error");
                });
        },
        getSLTypeName(slTypeId) {
            const slType = this.slTypes.find(type => type.id === slTypeId);
            return slType ? slType.name : 'Unknown';
        },
        addSubsidiaryLedger() {
            this.modalTitle = "Add New Subsidiary Ledger";
            this.$bvModal.show("subsidiary-ledger-modal");
            this.$refs.subsidiaryLedgerModal.resetForm();
        },
        async submitSubsidiaryLedger(modalData) {
            modalData.campusId = this.$store.state.data.selectedCampus.id;
            
            if (modalData.id > 0) {
                await this.$store
                    .dispatch("subsidiaryledger/updateSubsidiaryLedger", {
                        subsidiaryLedgerId: modalData.id,
                        data: modalData
                    })
                    .then((res) => {
                        if (res.data.error) {
                            return this.showToast(res.data.errorMessage, "error");
                        }
                        const index = this.subsidiaryLedgers.findIndex(item => item.id === modalData.id);
                        if (index !== -1) {
                            this.subsidiaryLedgers.splice(index, 1, {
                                ...modalData,
                                filterKey: `${modalData.accountNumber || ''} ${modalData.client || ''} ${modalData.projectName || ''} ${modalData.contractNo || ''} ${this.getSLTypeName(modalData.slTypeId)}`.toLowerCase()
                            });
                        }
                        this.showToast("Subsidiary Ledger updated successfully", "success");
                        this.$bvModal.hide("subsidiary-ledger-modal");
                    })
                    .catch((error) => {
                        this.showToast("Failed to update Subsidiary Ledger", "error");
                    });
            } else {
                await this.$store
                    .dispatch("subsidiaryledger/createSubsidiaryLedger", {
                        data: modalData,
                        campusId: modalData.campusId
                    })
                    .then((res) => {
                        if (res.data.error) {
                            return this.showToast(res.data.errorMessage, "error");
                        }
                        this.subsidiaryLedgers.push({
                            ...res.data,
                            filterKey: `${res.data.accountNumber || ''} ${res.data.client || ''} ${res.data.projectName || ''} ${res.data.contractNo || ''} ${this.getSLTypeName(res.data.slTypeId)}`.toLowerCase()
                        });
                        this.showToast("Subsidiary Ledger added successfully", "success");
                        this.$bvModal.hide("subsidiary-ledger-modal");
                    })
                    .catch((error) => {
                        this.showToast("Failed to add Subsidiary Ledger", "error");
                    });
            }
        },
        editSubsidiaryLedger(item) {
            let data = JSON.parse(JSON.stringify(item));
            this.modalTitle = `Edit Subsidiary Ledger - ${item.code}`;
            this.$bvModal.show("subsidiary-ledger-modal");
            this.$refs.subsidiaryLedgerModal.updateData(data);
            this.$refs.subsidiaryLedgerModal.referenceType = data.referenceType;
            this.$refs.subsidiaryLedgerModal.selectedReference = data.clientDto;
        },
        deleteSubsidiaryLedger(item) {
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, delete it!",
            }).then((result) => {
                if (result.value) {
                    this.$store
                        .dispatch("subsidiaryledger/removeSubsidiaryLedger", item.id)
                        .then((res) => {
                            if (res.data.error) {
                                return this.showToast(res.data.errorMessage, "error");
                            }
                            const index = this.subsidiaryLedgers.findIndex(i => i.id === item.id);
                            if (index !== -1) {
                                this.subsidiaryLedgers.splice(index, 1);
                            }
                            this.showToast("Subsidiary Ledger deleted successfully", "success");
                        })
                        .catch((error) => {
                            this.showToast("Failed to delete Subsidiary Ledger", "error");
                        });
                }
            });
        },
        viewGeneralLedger(item) {
            this.selectedSubsidiaryLedger = item;
            this.transactionsModalTitle = `SL Transactions - ${item.code}`;
            this.$bvModal.show("subsidiary-ledger-transactions-modal");
        },
        printTransaction(transaction) {
            console.log("Print transaction:", transaction);
            this.showToast("Print transaction functionality to be implemented", "info");
        },
    },
};
</script>

<template>
    <Layout 
        @changeCycle="changeData($event, $store.state.data.selectedCampus.id)"
        @changeCampus="changeData($store.state.data.cycle, $event.id)"
    >
        <PageHeader :title="title" :items="items" />
        
        <template v-if="loading">
            <div class="d-flex justify-content-between mb-3">
                <div class="d-flex gap-1">
                    <b-skeleton width="280px" height="35px"></b-skeleton>
                    <b-skeleton width="70px" height="35px"></b-skeleton>
                </div>
                <b-skeleton width="150px" height="35px"></b-skeleton>
            </div>
            <div class="mb-2">
                <b-skeleton width="100%" height="50px"></b-skeleton>
            </div>
            <div class="mb-2" v-for="x in 10" :key="x">
                <b-skeleton width="100%" height="60px"></b-skeleton>
            </div>
        </template>
        
        <template v-else>
            <div class="d-flex justify-content-between pb-2 border-bottom">
                <div class="d-flex gap-1">
                    <b-form-input
                        v-model="filter"
                        type="text"
                        placeholder="Search Subsidiary Ledgers..."
                        style="width:280px;"
                    ></b-form-input>
                    <b-form-select
                        class="form-select"
                        v-model="perPage"
                        style="width:70px"
                        :options="pageOptions"
                    ></b-form-select>
                </div>
                <div>
                    <b-button variant="primary" @click="addSubsidiaryLedger">
                        <i class="bx bx-plus align-middle me-2"></i>Create New
                    </b-button>
                </div>
            </div>
            
            <div class="mt-3">
                <SubsidiaryLedgerTable 
                    :subsidiaryLedgers="subsidiaryLedgers"
                    :slTypes="slTypes"
                    :filter="filter"
                    :perPage="perPage"
                    :loading="loading"
                    @edit-ledger="editSubsidiaryLedger"
                    @delete-ledger="deleteSubsidiaryLedger"
                    @view-ledger="viewGeneralLedger"
                />
            </div>
        </template>
        
        <SubsidiaryLedgerModal 
            ref="subsidiaryLedgerModal" 
            :modalTitle="modalTitle"
            :slTypes="slTypes"
            @submit="submitSubsidiaryLedger"
        />
        
        <SubsidiaryLedgerTransactionsModal
            :subsidiaryLedger="selectedSubsidiaryLedger"
            :modalTitle="transactionsModalTitle"
            @print-transaction="printTransaction"
        />
    </Layout>
</template>
